import Form from "@subly/s1/ui/atom/Form";

import { usePaywall, useWelcomeCMS } from "../fabric";
import Actions from "./Actions";


export default function CMS() {
	const { form, cms } = useWelcomeCMS();

	return (
		<Form>
			<form.AppField name="cms" listeners={{ onChange: () => form.setFieldValue("paywall", "") }} children={(field) => <field.Select label="CMS" options={cms.data} required/>} />
			<form.Subscribe selector={(state) => state.values.cms}>
				{(cmsId) => {
					const paywalls = usePaywall(cmsId);
					return <form.AppField name="paywall" children={(field) => <field.Select options={paywalls.data} disabled={!cmsId} label="Paywall" required />} />;
				}}
			</form.Subscribe>
			<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
				{([canSubmit, isSubmitting]) => <Actions canSubmit={canSubmit} isSubmitting={isSubmitting} onClick={form.handleSubmit} />}
			</form.Subscribe>
		</Form>
	);
};